import BaseService from "./geral/BaseService";

const base = "ControleEstoque";

export default class ControleEstoqueService extends BaseService {
    constructor() {
        super(base);
    }

    Listar (clienteId = "",cnpjCliente = "", modalidade = "", dtEntradaInicial = "",dtEntradaFinal = "",dtDesovaInicial = "",dtDesovaFinal = "", dtBlFinalizInicial="", dtBlFinalizFinal="", codStatusBl="") {
        return super.httpGet(`/${base}/ListarEstoqueCliente?clienteId=${clienteId}&cnpjCliente=${cnpjCliente}&dtEntradaInicial=${dtEntradaInicial}&dtEntradaFinal=${dtEntradaFinal}&dtDesovaInicial=${dtDesovaInicial}&dtDesovaFinal=${dtDesovaFinal}&dtBlFinalizInicial=${dtBlFinalizInicial}&dtBlFinalizFinal=${dtBlFinalizFinal}&codStatusBl=${codStatusBl}`);
    }
    
    ListarClientes () {
        return super.httpGet(`/${base}/ListarClientes`);
    }
    
    ListarFiltros() {
        return super.httpGet(`/${base}/ListarFiltros`);
    }
    
    ListarCamposExib() {
        return super.httpGet(`/${base}/ListarCamposExib`);
    }

    ListarStatusBl() {
        return super.httpGet(`/${base}/ListarStatusBl`);
    }
    
    SalvarFiltro(filtro) {
        return super.httpPost(`/${base}/SalvarFiltro`, filtro);
    }
    
    // apagarFiltro() {
    //     return super.httpPost(`/${base}/ApagarFiltro`, null);
    // }

    
    obrigatorioMovimentacao = [];

    novoValor = {
        valor: "0",
        nome: "Padrão",
        descricao: "Desc",
        dadosTabela: this.obrigatorioMovimentacao
    }

    novoFiltro = {
        Id: 0,
        ApplicationId: 1,
        TaskId: 1,
        OperationId: 1,
        MembershipuserId: 0,
        TipoObjeto: "FILTRO",
        NomeObjeto: "",
        DescricaoObjeto: "Filtro Movimentacao",
        ValorObjeto: "this.novoValor",
        DataUltimaModificacao: ""
    }
}



// WEBPACK FOOTER //
// ./src/services/ControleEstoqueService.js